import React from 'react'

function TenderTextVARSA() {
  return (
    <embed src="\pdfs\EAT1.5.8.1_VA-RSA_Displacement_outlet_for_indoor_firing_ranges_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextVARSA